import { useEffect, useCallback } from 'react'
import { useStore, useChannels, useActiveChannelId } from '../store/index.js'
import { channelsApi, ApiError } from '../lib/api.js'

/**
 * useChannels
 *
 * Charge la liste des chaînes au montage et expose
 * la chaîne active ainsi que l'action pour en changer.
 *
 * À monter dans le composant racine juste après usePlayoutSync.
 */
export function useChannelList() {
  const channels         = useChannels()
  const activeChannelId  = useActiveChannelId()
  const { setChannels, setActiveChannel, setChannelsLoading, setChannelsError } = useStore()

  const load = useCallback(async () => {
    setChannelsLoading(true)
    setChannelsError(null)
    try {
      const list = await channelsApi.list()
      setChannels(list)

      // Active automatiquement la première chaîne si aucune n'est sélectionnée
      if (!activeChannelId && list.length > 0) {
        setActiveChannel(list[0].id)
      }
    } catch (err) {
      setChannelsError(err instanceof ApiError ? err.message : 'Erreur chargement chaînes')
    } finally {
      setChannelsLoading(false)
    }
  }, [activeChannelId, setChannels, setActiveChannel, setChannelsLoading, setChannelsError])

  useEffect(() => { load() }, [load])

  return {
    channels,
    activeChannelId,
    reload: load,
    setActiveChannel: (id: string) => useStore.getState().setActiveChannel(id),
  }
}
